export enum CampaignRoutes {
  root = 'campaigns',
  all = 'all',
  create = 'create',
  edit = 'edit',
  detail = 'detail',
  clone = 'clone',
}
